<template>
<button
  class="btn"
  type="button"
  :disabled="disabled || isLoading"
  :style="buttonStyle"
  @click="onClick">
  <strong v-if="isLoading">Adicionando ao carrinho...</strong>
  <strong
    v-else
    :key="label">
    {{ label }}
  </strong>
</button>
</template>

<script>

export default {
  components: {},
  props: {
    disabled: {
      type:     Boolean,
      default:  () => false,
      required: true
    },
    isLoading: {
      type:     Boolean,
      default:  () => false,
      required: true
    },
    label: {
      type:     String,
      default:  () => 'Reservar agora',
      required: false
    },
    primaryColor: {
      type:     String,
      default:  () => '#E88A1D',
      required: false
    },
  },
  emits: ['click'],
  computed: {
    buttonStyle() {
      return {
        backgroundColor: this.primaryColor,
        opacity:         (this.disabled || this.isLoading) ? '0.55' : '1',
      };
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  }
};
</script>

<style scoped>
.btn {
    width: 100%;
    text-align: center;
    border: 0px;
    border-radius: 10px;
    padding: 16px;
    color: white;
    cursor: pointer;
    transition: opacity 0.15s;
    font-size: 15px;
}

.btn[disabled] {
    cursor: default;
}
</style>
